import React from 'react';
import { SmartImage } from '../SmartImage';
import styles from '../../utils/styles/components/HeroStage/style.module.css';

export const HeroStage = () => {
  return (
    <section className={styles.hero} id="hero">
      <div className={styles.stage}>
        <div className={styles.backdrop} />
        <div className={styles.content}>
          
          <div className={styles.visual}>
            <div className={styles.visualFrame}>
              <div className={styles.visualPlate}>
                <div aria-hidden="true" className={styles.visualAura} />
                <SmartImage
                  alt="Sylvie Willms sur scène avec un cheval noir"
                  className={styles.visualBackground}
                  decoding="async"
                  src="/images/instagram/fond_de_scene.png"
                />
              </div>
              <SmartImage
                alt="Danseur en second plan"
                className={styles.visualSecondaryFront}
                decoding="async"
                src="/images/instagram/danseur_transparent.png"
              />
              <SmartImage
                alt="Sylvie Willms et son cheval, ailes déployées"
                className={styles.visualCutout}
                decoding="async"
                src="/images/aile_fond_transparent_couperenbas.png"
              />
            </div>
            <div className={styles.copy}>
            {/* <span className={styles.kicker}>Art équestre, souffle en scène.</span> */}
            <h3 className={styles.title}>Entrer dans la lumière.</h3>
            <p className={styles.text}>Un cheval, un souffle, une lumière...</p>
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};
